import { mutator } from 'satcheljs';
import { onAttachmentViewStateIdChange } from '../actions/internalActions';
import { getOrCreateSxSStoreData } from 'owa-sxs-store';

mutator(onAttachmentViewStateIdChange, actionMessage => {
    const { attachmentViewStateId, sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).attachmentViewStateIdFromListView = attachmentViewStateId;
});
